export default "__VITE_ASSET__1ymFlJaT__"